import Cell from 'src/components/cell';
export default {
    props: {
        // 是否在选择接待分组时使用新的选择pannel common-selector,支持搜索
        useNewGroupSelectPanel: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CommonSelect: (r) => {
            window._rhinoComponents.marketRequire('common-select', '0.0.1').then((res) => {
                r(res);
            });
        },
        Cell,
    },
    data() {
        return {
            maps: {
                value: 'id',
                text: 'name',
            },
            value: [
                {
                    id: 'aaa',
                    name: 'bbbb',
                },
            ],
            commonSelectData: {
                group: {
                    key: 'triggerDemo',
                },
            },
        };
    },
    computed: {
        pageUrl() {
            return this.isVideoStandalone ? '/tp/videoServiceStandalone/index' : '/tp/IMAccessSet/page';
        },
    },
    methods: {
        listFunction(index, count, searchValue, dimValue) {
            let params = {
                index,
                count: 15,
            };
            if (!this.isVideoStandalone) {
                params = { ...params, ...this.extraParams };
            }
            const ajaxConfig = this.isVideoStandalone
                ? Gateway.post('/receptionConf/videoReceptionGroup/list', params, { originRes: true })
                : this.$ajax.gatewayPost('/v1/kf/reception/receptionConf/accessSet/fullList', params);
            // 搜索时，用搜索的url即可
            if (searchValue) {
                params.keyWord = searchValue;
            }
            return ajaxConfig.then(
                (res) => {
                    if (res.r === 0 || res.code === 0) {
                        return res.data.record || [];
                    }
                    this.$message.error(res.message || '获取数据失败');
                },
                (error) => {
                    this.$message.error(error || '获取数据失败');
                },
            );
        },
        refresh() {
            this.$refs.groupSelectorRef.refresh();
        },
        confirm(val) {
            this.onSelectChange(val.options[0]);
        },
    },
};
